import React from 'react';
import { Button } from '../Button';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';
import '../styles/pages.css';

export default function Services() {
  const services = [
    {
      id: 1,
      icon: '🏗️',
      title: 'Infrastructure Design',
      description: 'Enterprise-grade infrastructure planning and implementation'
    },
    {
      id: 2,
      icon: '🔐',
      title: 'Security Consulting',
      description: 'Comprehensive security assessments and recommendations'
    },
    {
      id: 3,
      icon: '⚡',
      title: 'Performance Optimization',
      description: 'System optimization for maximum efficiency'
    },
    {
      id: 4,
      icon: '📊',
      title: 'Data Analytics',
      description: 'Transform data into actionable business insights'
    },
    {
      id: 5,
      icon: '🤖',
      title: 'AI Implementation',
      description: 'Custom AI solutions for your business needs'
    },
    {
      id: 6,
      icon: '🎓',
      title: 'Training & Support',
      description: '24/7 technical support and team training'
    }
  ];

  return (
    <>
      <SEO
        title='Our Services'
        description='Comprehensive IT solutions tailored to your business: infrastructure design, security consulting, performance optimization, data analytics, AI implementation, and 24/7 support.'
        path='/services'
      />
      <main className='services'>
        <div className='section-header'>
          <h1>Our Services</h1>
          <p>Comprehensive IT solutions tailored to your business</p>
        </div>

        <div className='services-grid' style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', maxWidth: '1200px', margin: '3rem auto' }}>
          {services.map(service => (
            <div key={service.id} className='service-card glass-dark' style={{ padding: '2rem', borderRadius: '1rem', border: '1px solid rgba(6, 182, 212, 0.1)', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ fontSize: '3rem' }}>{service.icon}</div>
              <h3 style={{ color: '#fff' }}>{service.title}</h3>
              <p style={{ color: '#9ca3af' }}>{service.description}</p>
              <Button buttonStyle='btn--outline' buttonSize='btn--medium' style={{ marginTop: 'auto' }}>
                Learn More
              </Button>
            </div>
          ))}
        </div>
      </main>
      <Copyrights />
      <Footer />
    </>
  );
}
